import { Injectable } from '@angular/core';
import { BehaviorSubject, map } from 'rxjs';
import { Partner, PartnerUnique } from '../model/partner.model';
import { partnerSalons } from './data';

@Injectable()
export class PartnersService {
    private readonly data$ = new BehaviorSubject<Partner[]>([...partnerSalons].sort((a, b) => a.order - b.order));

    readonly voivodeships$ = this.data$.pipe(map((partners) => [...new Set(partners.map((partner) => partner.voivodeship))]));
    readonly partners$ = (voivodeship: string) => this.data$.pipe(map((partners) => partners.filter((partner) => partner.voivodeship === voivodeship)));
    readonly partner$ = (path: string) => this.data$.pipe(map((partners) => partners.find((partner) => partner.path === path) || null));

    readonly partnersUnique$ = (voivodeship: string) =>
        this.data$.pipe(
            map((partners) => partners.filter((partner) => partner.voivodeship === voivodeship)),
            map((partners) => {
                return partners.reduce(
                    (acc, current) => {
                        const index = acc.findIndex((item) => item.name === current.name);

                        if (index === -1) {
                            acc.push({
                                name: current.name,
                                logo: current.logo,
                                bgColor: current.bgColor,
                                facilities: [current],
                            });
                        } else {
                            acc[index].facilities.push(current);
                        }

                        return acc;
                    },
                    <PartnerUnique[]>[],
                );
            }),
        );
}
